import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Chart } from 'chart.js';
import * as randomColor from 'randomcolor';

export interface DoughnutChartData {
  label: string;
  value: number;
}

@Component({
  selector: 'ma-doughnut-chart',
  templateUrl: './doughnut-chart.component.html',
  styleUrls: ['./doughnut-chart.component.scss'],
})
export class DoughnutChartComponent implements OnInit {
  @ViewChild('chart', { static: true }) private chartRef;
  @Input() set data(data: DoughnutChartData[]) {
    const { labels, datasets } = data.reduce(
      (acc, curr) => ({
        labels: acc.labels.concat(curr.label),
        datasets: acc.datasets.concat(curr.value),
      }),
      { labels: [], datasets: [] },
    );
    this.generateChart(labels, datasets);
  }

  chart: Chart;
  colors = randomColor({
    count: 1000,
    luminosity: 'light',
    hue: 'blue',
  });

  generateChart(labels: string[] = [], data: number[] = []) {
    this.chart = new Chart(this.chartRef.nativeElement, {
      type: 'doughnut',
      data: {
        labels,
        datasets: [
          {
            label: '# of Votes',
            data,
            backgroundColor: this.colors,
          },
        ],
      },
      options: {
        legend: {
          display: false,
        },
      },
    });
  }

  ngOnInit() {}
}
